module.exports = __webpack_public_path__ + "static/media/icon-order.772e4a99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/icon-order.svg
// module id = 124
// module chunks = 0